import React from "react";
import "./App.css";

import { BrowserRouter, Routes, Route , Navigate } from "react-router-dom";
import { ThemeProvider } from "./context/ThemeContext";
import { Toaster } from "./components/ui/sonner";
import LandingPage from "./components/landing/LandingPage";
import WhatsAppFloatingButton from "./components/landing/WhatsAppFloatingButton";
import PrivacyPolicy from "./components/landing/PrivacyPolicy";
import Cookies from "./components/landing/Cookies";
import CookieConsentManager from "./utils/cookieManager";


import IndustriesPage from "./components/landing/IndustriesPage";
import IndustryDetail from "./components/landing/IndustryDetail";

function App() {
  return (
    <ThemeProvider>
      <div className="App">
        <Toaster position="top-center" richColors />

        <BrowserRouter>
        <CookieConsentManager/>

          {/* Routes */}
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/PrivacyPolicy" element={<PrivacyPolicy />} />
            <Route path="/Cookies" element={<Cookies />} />

            <Route path="/industries" element={<IndustriesPage />} />
            <Route path="/industries/:slug" element={<IndustryDetail />} />
           <Route path="*" element={<Navigate to="/" replace />} />
              
          </Routes>

          {/* Floating WhatsApp Button */}
          <WhatsAppFloatingButton />
        </BrowserRouter>
      </div>
    </ThemeProvider>
  );
}

export default App;
